export var telegramBotName = process.env.TELEGRAM_BOT_NAME || 'ihaveimpulse_bot';
